import { Upload, Calculator, List, FileSpreadsheet, TrendingUp, Download } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';

export default function QuickActions() {
  const navigate = useNavigate();

  const actions = [
    {
      icon: Upload,
      label: 'Import Data',
      description: 'Upload Excel files',
      color: 'bg-blue-600 hover:bg-blue-700',
      onClick: () => navigate('/import')
    },
    {
      icon: Calculator,
      label: 'Run Calculations',
      description: 'Calculate tariff impacts',
      color: 'bg-green-600 hover:bg-green-700',
      onClick: () => navigate('/opportunities'),
      badge: 'Coming Soon'
    },
    {
      icon: List,
      label: 'View Opportunities',
      description: 'Browse all parts',
      color: 'bg-purple-600 hover:bg-purple-700',
      onClick: () => navigate('/opportunities')
    },
    {
      icon: FileSpreadsheet,
      label: 'Download Template',
      description: 'Get import template',
      color: 'bg-orange-600 hover:bg-orange-700',
      onClick: () => navigate('/import')
    }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
        <CardDescription>Common tasks and workflows</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-3">
          {actions.map((action, idx) => (
            <Button
              key={idx}
              variant="outline"
              className="h-auto p-4 flex flex-col items-start gap-2 hover:border-blue-600 hover:bg-blue-50 relative"
              onClick={action.onClick}
            >
              <div className={`p-2 rounded-lg ${action.color} text-white`}>
                <action.icon size={20} />
              </div>
              <div className="text-left">
                <div className="font-semibold text-sm">{action.label}</div>
                <div className="text-xs text-gray-500">{action.description}</div>
              </div>
              {action.badge && (
                <span className="absolute top-2 right-2 bg-yellow-100 text-yellow-800 text-xs px-2 py-0.5 rounded-full font-medium">
                  {action.badge}
                </span>
              )}
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
